import { render, staticRenderFns } from "./StyleCommentsFilter.vue?vue&type=template&id=7355efba&"
import script from "./StyleCommentsFilter.vue?vue&type=script&lang=js&"
export * from "./StyleCommentsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports